/*
    Title: Buefy Plugin
    Description: Allows Vue to use Buefy elements
    Author: James Kingsthaite
*/

// Imports Dependencies
import Vue from 'vue';
import Buefy from 'buefy';

// Sets Buefy with config
Vue.use(Buefy, {
	defaultIconPack: "fas",
	defaultIconComponent: "font-awesome-icon"
});